import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { axiosInstance } from "../../utils/tokenSetCookie";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const Logout: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const LogoutSection = async () => {
      try {
        const response = await axiosInstance.post(
          API_BASE_URL + "users/logout"
        );
        if (response.status >= 200 && response.status <= 300) {
          Cookies.remove("userToken");
          const authChannel = new BroadcastChannel("auth");
          authChannel.postMessage("logout");
          localStorage.removeItem("userToken"); // If stored in localStorage
          sessionStorage.removeItem("userToken"); // If stored in sessionStorage
          localStorage.removeItem("currentAnimId"); // If stored in sessionStorage
          localStorage.removeItem("currentSystemId"); // If stored in sessionStorage
          localStorage.removeItem("firstName"); // If stored in sessionStorage
          localStorage.removeItem("lastName"); // If stored in sessionStorage
          // localStorage.removeItem("lng"); // If stored in sessionStorage
          localStorage.removeItem("selectedAnimationId"); // 
          localStorage.removeItem("selectedSystemId");
          localStorage.removeItem("selectedQuality");
          localStorage.removeItem("activeTab");
          localStorage.removeItem("selectedSystemNumber");
          localStorage.removeItem("isPlaying");


        } else {
          console.log("Error");
        }
      } catch (err) {
        console.log("Error", err);
      }
    };
    LogoutSection(); // Passing the payload as an argument
    // Redirect to the login page or home page
    navigate("/login");
  }, [navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <h2>Logging out...</h2>
    </div>
  );
};

export default Logout;
